import React from 'react';
import {UserStatusType, UserStatusTypeLabels, UserStatusValues} from '../../../domain';
import {MultiMappingSelect} from './base/MultiMappingSelect';
import {SingleMappingSelect} from './base/SingleMappingSelect';

type UserStatusOption = {
  value: UserStatusType;
  label: string;
};

const UserStatusOptions: UserStatusOption[] =
  UserStatusValues.map(status => ({
    value: status,
    label: UserStatusTypeLabels[status]
  }));

function getOptionValue(option: UserStatusOption) {
  return option.value;
}

function getOptionLabel(option: UserStatusOption) {
  return option.label;
}

type UserStatusSelectProps = {
  value: UserStatusType | null;
  onChange: (userStatusType: UserStatusType | null) => void;
  onBlur?: () => void;
};

export class UserStatusSelect extends React.Component<UserStatusSelectProps> {
  render() {
    return (
      <SingleMappingSelect<UserStatusOption, UserStatusType>
        options={UserStatusOptions}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        value={this.props.value}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}/>);
  }
}

type UserStatusesSelectProps = {
  value: UserStatusType[];
  onChange: (userStatusType: UserStatusType[]) => void;
  onBlur?: () => void;
};

export class UserStatusesSelect extends React.Component<UserStatusesSelectProps> {
  render() {
    return (
      <MultiMappingSelect<UserStatusOption, UserStatusType>
        options={UserStatusOptions}
        getValue={getOptionValue}
        getLabel={getOptionLabel}
        value={this.props.value}
        onChange={this.props.onChange}
        onBlur={this.props.onBlur}/>);
  }
}
